﻿import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';
import 'rxjs/add/operator/pairwise';
// APP
import { EntityService } from '../../services/entity.service';
import { AccountService } from '../../services/account.service'; 
import { SharedService } from '../../services/shared.service';
import { AuthenticationService } from '../../services/authentication.service';
import { FoucsChangeService } from '../../services/focuschange.service'; 
import { AddAppName } from '../../viewmodel'; 
import { Animations } from '../common/animations';

@Component({
    selector: 'application-name',
    templateUrl: './addapplication.component.html',
    providers: [EntityService, AccountService],
    animations: [Animations.flyInOut]
})

export class AddApplicationComponent implements OnInit {

    animate: string = 'active';
    title: string = 'Add new application';
    projectId: number = 0; 
    createAppliication: boolean = false;
    pageError: any = [];
    pageSuccess: any = [];
    submitted: boolean = false;
    appNameForm: FormGroup;
    appName: string = '';
    appNameLabel: string = ''; 
    appIdLabel: string = '';
    appStatus: string = '';  
    appMode: string = ''; 
    model: any; 
    isModified = false;
    isIncompleteProfile: boolean = false;

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private entityService: EntityService
        , private accountService: AccountService
        , private sharedService: SharedService
        , private authenticationservice: AuthenticationService
        , private foucsChangeService: FoucsChangeService) {
                
        this.model = new AddAppName();        
    }

    ngOnInit() {
         
        let ids = this.sharedService.getJsonData("id");
     
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = ids.projectId;

                if (this.projectId == 0) {
                    this.createAppliication = true;  
                    this.appStatus = 'Draft';                  
                }
                else {

                    this.createAppliication = false;
                    this.title = "Edit application name";
                    this.appNameLabel = this.appName = ids.appName;
                    this.appIdLabel = ids.appIdLabel;
                    this.appStatus = ids.appStatus;
                    this.appMode = ids.appMode;            
                }
            }
        }
        else {
             this.createAppliication = true; 
             this.projectId = 0;
             this.appStatus = 'Draft'; 
        }
       
        this.appNameForm = this.frmBuilder.group({ appName: ['', [Validators.required]] });

        var user = this.sharedService.getJsonData("loggedInUser"); 
        this.getAccountByUserId(user.UserID);
		
    }     
    
    next(button) {
        this.submitted = true;
        if (this.appName.trim() == '' || this.appName == null) {
            this.appName = '';
            return false;
        }

        if (this.appName.length > 0)
            this.appName = this.appName.trim();
        //this.appName = this.appName.replace(/  +/g, ' ');        

        this.model.AppName = this.appName;
        this.model.ProjectId = this.projectId;

        this.entityService.addApplicationName(JSON.stringify(this.model)) 
            .subscribe(
                success => this.doOnSuccess(success, button, this.appName),
            error => {
                if (error.status == 401)
                    this.router.navigate(["/login?session=0"]);
                if (error.ExceptionMessage == null && error.MessageDetail != '')
                    error.ExceptionMessage = error.MessageDetail; 
				
                this.showError(error.ExceptionMessage);
            })
    }

    doOnSuccess(success, button, appName)
    {   
        if (!success.Success) {
            if (success.StatusMessage && success.StatusMessage.indexOf('Project Name already exists') !== -1) {
                this.showErrorAlert('This application name already exists. Please provide a unique application name.');
            }
            else {
                this.showError(success.StatusMessage);
            }
        }
        else {

            //success case
            if (success.Result != null) {
                var idLabel = 'ID - ' + success.Result;
                this.sharedService.setData('id', JSON.stringify({ 'projectId': success.Result, 'appName': appName, 'appIdLabel': idLabel, 'appStatus': this.appStatus, 'appMode': this.appMode }));
            }
            if (button == 'NEXT') {
                    this.router.navigate(['/information/housingarea']);
            }
            else if (button = 'LATER') {
                this.sharedService.navigateSummary(); 
            }
        }
    }

     home() {
        this.sharedService.navigateHome();
    }

     summary() {
         this.sharedService.navigateSummary();
     }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
     }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }
	
	 showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    valueChanged()
    {
        this.isModified = true;
    }

    getAccountByUserId(email) {
        
        this.accountService.getAccountByUserId(email)
            .subscribe(
            successResp => {
                if (!successResp.Success) {
                    //this.pageError.push(successResp.StatusMessage);
                }
                else {
                    var firstName = successResp.Result.FirstName;
                    var lastName =  successResp.Result.LastName;
                    var emailAddr = successResp.Result.UserID;
                    var hphone = successResp.Result.HomePhone;
                    var orgName = successResp.Result.OrganizationName
                    if ( 
                        firstName == null || firstName == 'N_A' || firstName.trim() == ''
                        || lastName == null || lastName == 'N_A' || lastName.trim() == '' 
                        || emailAddr == null || emailAddr.trim() == '') {

                       // this.updateProfile();  // redirect to NYC ID profile page. user info need to update in NYCID database server. 
                        this.isIncompleteProfile = true;
                        this.foucsChangeService.changeFocus(false);
                        return false; 
                    }

                    if (orgName == null || orgName.trim() == ''
                        || hphone == null || hphone.trim() == '') {

                        this.sharedService.navigateAccount();
                    }
                }
            },
            error => {
                window.scrollTo(0, 0);
            })
    }

    updateProfile() {
        var profileUrlLink = '';
        this.authenticationservice.getUpdateProfile()
            .subscribe(profileUrl => {
                profileUrlLink = profileUrl.d;
                window.location.href = profileUrlLink;
            });
    }


}

